import '../App.css';
import { Link, useLocation } from 'react-router-dom';

var Header = () => {
  const location = useLocation();
  const onMint = location.pathname === '/mint';

  return (
    <div className="title-bar">
      <h1 className="header-text">Impact Keys</h1>
      <div className="title-nav">
        <Link to="/info" className={`title-nav-link${!onMint ? ' title-nav-link-active' : ''}`}>Info</Link>
        <span className="title-nav-sep">|</span>
        <Link to="/mint" className={`title-nav-link${onMint ? ' title-nav-link-active' : ''}`}>Mint</Link>
      </div>
    </div>
  );
};

export default Header;
